module.exports = __webpack_public_path__ + "img/SABA-Sports-Title-Logo.a732df88.png";